<div class="size-container">
  <div class="close-icon" (click)="closeBrowser()">Luk modul <mat-icon fontIcon="close"/></div>
  <router-outlet/>
</div>
